<template>
  <v-row class="no-gutters">
    <v-col class="col-12">
      <v-autocomplete
        ref="searchTextField"
        :loading="isLoading"
        :items="usersInstance.userBookings"
        :search-input.sync="searchString"
        clearable
        :filter="(v) => v"
        :value="selectedUserBookings"
        :label="$t('shopBackendBookingOverview.searchDefaultText')"
        prepend-icon="fa-search"
        :no-data-text="$t('shopBackendBookingOverview.noSearchResult')"
        outlined
        :rules="[(v) => !required || !!v || $t('createBooking.selectPerson')]"
        @input="
          (v) => {
            this.$emit('update:selectedUserBookings', v)
          }
        "
      >
        <!-- selected item -->
        <template #selection="data">
          <display-user-helper :user="data.item" only-name />
        </template>

        <!--items -->
        <template #item="data">
          <display-user-helper :user="data.item" />
        </template>
      </v-autocomplete>
    </v-col>
  </v-row>
</template>

<script>
import UserBookings from '../../classes-shared/bookings/UserBookings'
import Users from '../../classes-shared/user/Users'
import DisplayUserHelper from './DisplayUserHelper'

export default {
  name: 'SearchUserAutocomplete',
  components: { DisplayUserHelper },
  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    usersInstance: {
      type: Users,
      required: true,
    },

    // the selected user with its bookings
    selectedUserBookings: {
      type: UserBookings,
      required: true,
    },

    // selectedUserBookings is mandatory (via rules)
    required: {
      type: Boolean,
      required: false,
      default: false,
    },

    // using the endpoint which also gets the bookings with the user
    searchForBookings: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  data() {
    return {
      searchString: null,

      lastStringSearched: null,
    }
  },

  mounted() {
    // trigger search
    this.searchEngine()
  },

  methods: {
    searchEngine() {
      setInterval(() => {
        if (
          this.searchString &&
          this.searchString.length > 2 &&
          this.searchString !== this.lastStringSearched
        ) {
          this.lastStringSearched = this.searchString
          this.performSearch()
        }
      }, 1000)
    },

    async performSearch() {
      let searchWords = this.lastStringSearched.split(' ')
      // max four words to allow a search
      if (searchWords.length > 4) return

      this.$emit('update:isLoading', true)
      this.$emit('lastStringSearched', this.lastStringSearched)

      // perform searching
      await this.usersInstance.searchUsersWithBookings(
        this.lastStringSearched.trim(),
        this.searchForBookings
      )
      this.$emit('update:isLoading', false)
    },

    focus() {
      this.$refs.searchTextField.focus()
    },
  },
}
</script>
